import { FormikProps, FormikValues, getIn } from "formik";
import Input from "@druva-apps/orion/lib/input";
import { ChangeEvent, FC, useCallback } from "react";

type RadioProps = {
  options: { label: string; value: string }[];
  name: string;
  validationProps?: FormikProps<FormikValues>;
  isInvalid: boolean;
};

const RadioInput: FC<RadioProps> = ({
  options,
  name,
  validationProps,
  isInvalid,
}) => {
  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const value = Number.isNaN(Number(e.target.value))
        ? e.target.value
        : Number(e.target.value);
      validationProps?.setFieldValue(name, value);
    },
    [name, validationProps],
  );

  return (
    <div>
      <div
        className="oui-d-flex oui-justify-content-start oui-align-items-center"
        style={{ gap: "1rem" }}
      >
        {options.map((option) => (
          <Input
            key={option.value}
            type="radio"
            role="radio"
            {...option}
            name={name}
            validationProps={validationProps}
            onChange={handleChange}
          />
        ))}
      </div>
      <div
        data-testid="orion-input-feedback"
        className="oui-d-block oui-invalid-feedback"
      >
        {isInvalid && getIn(validationProps?.errors, name)}
      </div>
    </div>
  );
};

export default RadioInput;
